
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { ChaseInvoiceStatus } from '../Model/ChaseInvoiceStatus';
import { Observable } from 'rxjs';
import { GetEnvVarService } from "../../../../service/get-env-var.service";

@Injectable()
export class InvoiceStatusService {

  private baseUrl: string;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }

  getTransactionStatusFromUID(uId: string): Observable<ChaseInvoiceStatus> {
    // debugger;
    return this.http.get(this.baseUrl + `/api/invoice/getTransactionStatusFromUID/` + uId).pipe(
      map(response => response as ChaseInvoiceStatus));
  }

}
